import styled from "styled-components";
import {
    EditBox,
    TrashBox,
} from "../modals/propertyManagementModal/propertyManagementModal.styled";

export const StyledRow = styled.div<{
    isHeader?: boolean;
    isHidden?: boolean;
}>`
    display: flex;
    background: ${(props) => props.theme.colors.neutral[100]};

    border-bottom: solid
        ${(props) =>
            props.isHeader
                ? `2px ${props.theme.colors.neutral[400]}`
                : `1px ${props.theme.colors.neutral[300]}`};

    &:last-child {
        border-bottom: none;
    }

    font-weight: ${(props) =>
        props.isHeader ? props.theme.fontWeight.bold : "default"};
`;

const Cell = styled.div`
    height: 3.6rem;
    display: grid;
    place-items: center;

    border-right: solid 0.5px ${(props) => props.theme.colors.neutral[200]};
    &:last-child {
        border-right: none;
    }
`;

export const StyledCell = styled(Cell)<{ isHidden?: boolean }>`
    width: 10rem;

    opacity: ${(props) => (props.isHidden ? 0.25 : 1)};
`;

export const StyledSubProductSelectorCell = styled(Cell)`
    width: 3.6rem;
    cursor: pointer;
    font-size: 1.2rem;
    transition: all 0.15s;

    color: ${(props) => props.theme.colors.neutral[500]};

    &:hover {
        font-size: 1.4rem;
        transition: all 0.15s;
        color: ${(props) => props.theme.colors.neutral[800]};
    }
`;

export const StyledDragHandleCell = styled(Cell)`
    width: 1.8rem;
    color: ${(props) => props.theme.colors.neutral[300]};
`;

export const SpacerCell = styled(Cell)<{ width?: string }>`
    width: ${(props) => props.width};
`;

export const TrashIconCell = styled(TrashBox)`
    border-right: solid 0.5px ${(props) => props.theme.colors.neutral[200]};
    height: 3.6rem;
    width: 3.6rem;
`;

export const ToggleVisibilityCell = styled(EditBox)<{ isHidden?: boolean }>`
    border-right: solid 0.5px ${(props) => props.theme.colors.neutral[200]};
    height: 3.6rem;
    width: 3.6rem;

    color: ${(props) =>
        props.isHidden
            ? props.theme.colors.neutral[300]
            : props.theme.colors.primary[300]};
`;
